import authAxios from 'src/modules/shared/axios/authAxios';
import AuthCurrentTenant from 'src/modules/auth/authCurrentTenant';

export default class PlanService {
  static async fetchCheckoutSessionId(plan, data?: any) {
    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.post(
      `/tenant/${tenantId}/plan/stripe/checkout`,
      {
        plan,
        ...(data || {}),
      },
    );

    return response.data;
  }

  static async fetchPortalUrl() {
    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.post(
      `/tenant/${tenantId}/plan/stripe/portal`,
    );

    return response.data.url;
  }

  static async fetchPricing() { return (await authAxios.get(`/tenant/${AuthCurrentTenant.get()}/plan/pricing`)).data; }
  static async fetchSubscription() { return (await authAxios.get(`/tenant/${AuthCurrentTenant.get()}/plan/subscription`)).data; }
  static async previewChange(body) { return (await authAxios.post(`/tenant/${AuthCurrentTenant.get()}/plan/preview`, body)).data; }
  static async changePlan(body) { return (await authAxios.post(`/tenant/${AuthCurrentTenant.get()}/plan/change`, body)).data; }
  static async cancelSubscription() { return (await authAxios.post(`/tenant/${AuthCurrentTenant.get()}/plan/cancel`)).data; }
  static async resumeSubscription() { return (await authAxios.post(`/tenant/${AuthCurrentTenant.get()}/plan/resume`)).data; }
}
